import type { JSX } from 'react';
import { Radio } from '@ksyos/design-system';
import { TabakOpties } from '@common/customControls/bariatrics';
import {
    RadioGroupFormGroup,
    TextAreaFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';

export function BariPreSecretarialAssistentMedScreeningReportEditTabak(): JSX.Element {
    return (
        <>
            <RadioGroupFormGroup
                fieldKey="tabak_gebruik"
                isRequired={true}
                label="Tabak gebruik"
            >
                {sortedTabakOpties.map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>
            <TextAreaFormGroup
                fieldKey="tabak_toelichting"
                label="Toelichting tabak"
            />
        </>
    );
}

const sortedTabakOpties = [
    TabakOpties.rookt_dagelijks_tabak,
    TabakOpties.rookt_soms_tabak,
    TabakOpties.rookt_passief_tabak,
    TabakOpties.rookte_vroeger,
    TabakOpties.niet_roker_maar_rookgedrag_in_verleden_onbekend,
    TabakOpties.heeft_nooit_gerookt,
    TabakOpties.anders,
];
